import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { useFetchUploadPhotosPositions } from "~/api/storyblok/useFetchUploadPhotosPositions";
import PhotosOverview, { FamiliesState } from "./PhotosOverview";
import { DEFAULT_SKIN_FAMILIES } from "./photos.const";

const SkinOverview = () => {
  const [searchParams] = useSearchParams();
  const selectedSkinCategories = searchParams.get("selected_categories");
  const { data, isLoading } = useFetchUploadPhotosPositions("skin");

  const [families, setFamilies] = useState<FamiliesState[]>(
    DEFAULT_SKIN_FAMILIES
  );

  return (
    <PhotosOverview
      data={data}
      isLoading={isLoading}
      families={families}
      setFamilies={setFamilies}
      selectedCategories={selectedSkinCategories}
    />
  );
};

export default SkinOverview;
